import React from "react";
import routes from "routes/routes";

import MP_LOGO from "../../assets/images/appicon.png";
import { NavLink } from "react-router-dom";

const CommonNavBar = ({ currentState, onChange }) => {
  return (
    <div className="w-1/5 h-screen sticky top-0">
      <img
        src={MP_LOGO}
        alt={"Mind Pulse"}
        className="w-24 h-24 object-contain"
      />

      <div className="flex flex-col mt-2">
        {routes?.map((route) => {
          return (
            <div key={route?.label}>
              <div className="px-4 mt-2 border-b">
                <p className="font-normal text-base text-[#5153F5]">
                  {route?.label ?? ""}
                </p>
              </div>

              {route?.children?.map((option) => {
                return (
                  <div
                    key={option?.name}
                    onClick={() => onChange(option?.name ?? "")}
                  >
                    <div className="w-full px-2 mt-1">
                      <NavLink
                        to={option?.to}
                        className={({ isActive }) =>
                          isActive
                            ? "bg-[#5153F5] rounded-lg px-4 py-3 text-white text-base font-medium flex flex-row items-center"
                            : "bg-transparent px-4 py-3 text-black text-base font-normal flex flex-row items-center"
                        }
                      >
                        {option?.icon ?? null}
                        <p className="pb-0 mb-0">{option?.name ?? ""}</p>
                      </NavLink>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CommonNavBar;
